import React from "react";

const AccordionExpanded = ({ children }) => {
  return <div style={{ paddingTop: "24px" }}>{children}</div>;
};

export default AccordionExpanded;
